module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ctrsConfiguration":"CTRs Configuration"},"fr":{"ctrsConfiguration":"Configuration des CTRs"},"de":{"ctrsConfiguration":"Konfiguration CTRs"}}')
  delete Component.options._Ctor
}
